import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryHeader from './components/CategoryHeader';
import CategoryGrid from './components/CategoryGrid';
import CategoryFeatured from './components/CategoryFeatured';
import { categories } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  return (
    <>
      <Navbar />
      <main>
        <CategoryHeader />
        <CategoryGrid />
        <CategoryFeatured />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${category?.name || slug} - 吃瓜网黑料`,
            description: `${category?.description || slug + '相关内容合集'}，吃瓜网黑料国产精品爆料`,
            url: `https://chigua.example.com/category/${slug}`,
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜网黑料',
              url: 'https://chigua.example.com/',
            },
            inLanguage: 'zh-CN',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://chigua.example.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: category?.name || slug,
              },
            ],
          }),
        }}
      />
    </>
  );
}